import apiClient from './client';

// Progress / draw billing (CR #78)

export interface BillingMilestone {
  id: number;
  job_id: number;
  title: string;
  display_order: number;
  amount_type: 'percent' | 'fixed';
  amount_value: number;
  notes: string | null;
  invoice_id: number | null;
  invoice_number: string | null;
  invoice_status: string | null;
  invoice_total: number | null;
  invoice_paid: number | null;
}

export interface BillingContract {
  budget: number;
  revised: number;
}

export const getBillingMilestones = async (
  jobId: string | number,
): Promise<{ milestones: BillingMilestone[]; contract: BillingContract }> => {
  const { data } = await apiClient.get(`/jobs/${jobId}/billing-milestones`);
  return data.data;
};

export const createBillingMilestone = async (
  jobId: string | number,
  payload: { title: string; amount_type: 'percent' | 'fixed'; amount_value: number; notes?: string },
): Promise<BillingMilestone> => {
  const { data } = await apiClient.post(`/jobs/${jobId}/billing-milestones`, payload);
  return data.data;
};

export const seedBillingPreset = async (jobId: string | number): Promise<BillingMilestone[]> => {
  const { data } = await apiClient.post(`/jobs/${jobId}/billing-milestones`, { preset: true });
  return data.data;
};

export const updateBillingMilestone = async (
  jobId: string | number,
  id: number,
  payload: Partial<{ title: string; amount_type: 'percent' | 'fixed'; amount_value: number; notes: string | null }>,
): Promise<BillingMilestone> => {
  const { data } = await apiClient.put(`/jobs/${jobId}/billing-milestones/${id}`, payload);
  return data.data;
};

export const deleteBillingMilestone = async (jobId: string | number, id: number): Promise<void> => {
  await apiClient.delete(`/jobs/${jobId}/billing-milestones/${id}`);
};

export const generateDrawInvoice = async (
  jobId: string | number,
  id: number,
): Promise<{ milestone: BillingMilestone; invoice: { id: number; invoiceNumber: string } }> => {
  const { data } = await apiClient.post(`/jobs/${jobId}/billing-milestones/${id}/generate-invoice`);
  return data.data;
};
